import React, { useState, useEffect } from 'react';
import { FiUsers, FiBook, FiFileText, FiTrendingUp } from 'react-icons/fi';
import api from '../../utils/api';

const font = "'Outfit', sans-serif";
const green = '#10b981'; // Emerald 500
const darkGreen = '#065f46'; // Emerald 800
const lightGreen = '#ecfdf5'; // Emerald 50
const borderGreen = '#d1fae5'; // Emerald 100

const AdminDashboard = () => {
    const [stats, setStats] = useState({
        totalTeachers: 0,
        totalAssignments: 0,
        totalPapers: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await api.get('/api/admin/dashboard');
                if (res.data?.stats) {
                    setStats(res.data.stats);
                }
            } catch (err) {
                console.error("Error fetching admin stats:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    const statCards = [
        { title: 'Total Teachers', value: stats.totalTeachers, icon: <FiUsers size={24} />, color: '#3b82f6', bg: '#eff6ff' },
        { title: 'Active Assignments', value: stats.totalAssignments, icon: <FiBook size={24} />, color: '#10b981', bg: '#ecfdf5' },
        { title: 'Exam Papers Created', value: stats.totalPapers, icon: <FiFileText size={24} />, color: '#8b5cf6', bg: '#f5f3ff' },
        { title: 'System Status', value: 'Online', icon: <FiTrendingUp size={24} />, color: '#f59e0b', bg: '#fffbeb' },
    ];

    if (loading) {
        return <div style={{ padding: 40, fontFamily: font, color: darkGreen, textAlign: 'center' }}>Loading dashboard...</div>;
    }

    return (
        <div style={{ fontFamily: font, maxWidth: 1200, margin: '0 auto', animation: 'fadeIn 0.4s ease' }}>
            {/* Header */}
            <div style={{ marginBottom: 32 }}>
                <h1 style={{ fontSize: 28, fontWeight: 800, color: darkGreen, margin: '0 0 8px', letterSpacing: '-0.5px' }}>
                    Admin Dashboard
                </h1>
                <p style={{ margin: 0, color: '#4b5563', fontSize: 15 }}>
                    Welcome to the Swami Vivekananda Exam Portal administration interface. Here's an overview of the system.
                </p>
            </div>

            {/* Stats Grid */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                gap: 20,
                marginBottom: 32
            }}>
                {statCards.map((card, i) => (
                    <div key={i} style={{
                        background: '#fff',
                        borderRadius: 16,
                        padding: 24,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 20,
                        border: `1px solid ${borderGreen}`,
                        boxShadow: '0 4px 12px rgba(16,185,129,0.04)',
                        transition: 'transform 0.2s',
                        cursor: 'pointer'
                    }}>
                        <div style={{
                            width: 60, height: 60, borderRadius: 14,
                            background: card.bg, color: card.color,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            {card.icon}
                        </div>
                        <div>
                            <p style={{ margin: '0 0 4px', fontSize: 13, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                {card.title}
                            </p>
                            <h3 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>
                                {card.value}
                            </h3>
                        </div>
                    </div>
                ))}
            </div>

            {/* Main Content Area */}
            <div style={{
                background: '#fff',
                borderRadius: 16,
                padding: 32,
                border: `1px solid ${borderGreen}`,
                boxShadow: '0 4px 12px rgba(16,185,129,0.04)',
                textAlign: 'center',
                minHeight: 300,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div style={{
                    width: 80, height: 80, borderRadius: 20,
                    background: lightGreen, color: green, margin: '0 auto 20px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <FiTrendingUp size={36} />
                </div>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: darkGreen, margin: '0 0 12px' }}>
                    System Operations Normal
                </h2>
                <p style={{ margin: 0, color: '#6b7280', fontSize: 15, maxWidth: 500, lineHeight: 1.6 }}>
                    Use the sidebar navigation to manage teacher assignments, review submitted exam papers, and monitor the overall status of the examination portal.
                </p>
            </div>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default AdminDashboard;
